import { render, staticRenderFns } from "./proposal-list-employer-detail.vue?vue&type=template&id=05c4cf84"
import script from "./proposal-list-employer-detail.vue?vue&type=script&lang=js"
export * from "./proposal-list-employer-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports